import React, { useState, useEffect } from 'react';
import { FaSave, FaPlus, FaTrash, FaPlusCircle, FaTrashAlt } from 'react-icons/fa';

const AddSidebarItem = () => {
    const [existingMenus, setExistingMenus] = useState<any[]>([]);
    const [isNewGroup, setIsNewGroup] = useState(true);
    const [title, setTitle] = useState('');
    const [icon, setIcon] = useState('FaBox');
    const [subItems, setSubItems] = useState([{ name: '', path: '' }]);

    const fetchMenus = () => {
        fetch("http://localhost:2026/api/sidebar/all")
            .then(res => res.json())
            .then(data => setExistingMenus(data));
    };

    useEffect(() => { fetchMenus(); }, []);

    // Jab existing menu select karein, toh uska pura data load ho jaye
    const handleSelectExisting = (menuTitle: string) => {
        const m = existingMenus.find(x => x.title === menuTitle);
        if(m) {
            setTitle(m.title);
            setIcon(m.icon);
            // Path se '/frog-side/' hata kar load karein taaki edit aasan ho
            const cleanSubItems = m.subItems.map((s:any) => ({
                name: s.name,
                path: s.path.replace('/frog-side/', '')
            }));
            setSubItems(cleanSubItems);
        }
    };

    const deleteGroup = async () => {
        if(!window.confirm(`Delete entire "${title}" group?`)) return;
        const res = await fetch(`http://localhost:2026/api/sidebar/delete/${title}`, { method: 'DELETE' });
        if(res.ok) { alert("Group Deleted!"); window.location.reload(); }
    };

    const saveMenu = async () => {
        const formattedSubItems = subItems.map(item => ({
            name: item.name,
            path: item.path.startsWith('/frog-side/') ? item.path : `/frog-side/${item.path.replace(/^\//, '')}`
        }));

        const res = await fetch("http://localhost:2026/api/sidebar/add", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ title, icon, subItems: formattedSubItems })
        });
        if(res.ok) { alert("Sidebar Updated!"); window.location.reload(); }
    };

    return (
        <div className="p-10 max-w-4xl mx-auto bg-white rounded-[40px] shadow-sm border border-slate-100">
            <div className="flex justify-between items-center mb-8">
                <h2 className="text-3xl font-black tracking-tighter uppercase text-slate-800 italic">Sidebar Manager</h2>
                {!isNewGroup && title && (
                    <button onClick={deleteGroup} className="bg-red-50 text-red-500 px-6 py-3 rounded-2xl text-[10px] font-black tracking-widest hover:bg-red-500 hover:text-white transition-all flex items-center gap-2">
                        <FaTrashAlt /> DELETE GROUP
                    </button>
                )}
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-10 p-8 bg-slate-50 rounded-[30px]">
                <div>
                    <label className="text-[10px] font-black uppercase text-slate-400 ml-1">Config Type</label>
                    <div className="flex gap-4 mt-2">
                        <button onClick={() => {setIsNewGroup(true); setTitle(''); setSubItems([{name:'', path:''}])}} className={`flex-1 py-4 rounded-2xl font-black text-[10px] tracking-widest transition-all ${isNewGroup ? 'bg-[#006d5b] text-white' : 'bg-white text-slate-400'}`}>NEW</button>
                        <button onClick={() => setIsNewGroup(false)} className={`flex-1 py-4 rounded-2xl font-black text-[10px] tracking-widest transition-all ${!isNewGroup ? 'bg-[#006d5b] text-white' : 'bg-white text-slate-400'}`}>EDIT</button>
                    </div>
                </div>

                <div>
                    <label className="text-[10px] font-black uppercase text-slate-400 ml-1">Menu Title</label>
                    {isNewGroup ? (
                        <input className="w-full mt-2 p-4 bg-white rounded-2xl outline-none border border-slate-200 font-bold" placeholder="e.g. Users" value={title} onChange={e => setTitle(e.target.value)} />
                    ) : (
                        <select className="w-full mt-2 p-4 bg-white rounded-2xl outline-none border border-slate-200 text-sm font-bold" value={title} onChange={e => handleSelectExisting(e.target.value)}>
                            <option value="">-- Select Menu to Edit --</option>
                            {existingMenus.map(m => <option key={m.id} value={m.title}>{m.title}</option>)}
                        </select>
                    )}
                </div>
            </div>

            <div className="space-y-4">
                <h4 className="text-[10px] font-black text-[#006d5b] uppercase ml-2 tracking-widest">Manage Pages</h4>
                {subItems.map((sub, i) => (
                    <div key={i} className="flex flex-col md:flex-row items-center gap-4 bg-slate-50 p-6 rounded-[25px] border border-slate-100">
                        <div className="flex-1 w-full">
                            <input className="w-full bg-white p-3 rounded-xl outline-none font-bold text-slate-700" placeholder="Button Name" value={sub.name} onChange={e => {
                                let s = [...subItems]; s[i].name = e.target.value; setSubItems(s);
                            }} />
                        </div>
                        <div className="flex-[1.5] w-full border-l-0 md:border-l border-slate-200 md:pl-4 flex items-center gap-2">
                            <div className="flex-1 flex items-center bg-white p-3 rounded-xl">
                                <span className="text-slate-400 font-bold text-sm">/frog-side/</span>
                                <input className="flex-1 bg-transparent outline-none font-bold text-slate-700 ml-1" placeholder="path" value={sub.path} onChange={e => {
                                    let s = [...subItems]; s[i].path = e.target.value; setSubItems(s);
                                }} />
                            </div>
                            <button onClick={() => setSubItems(subItems.filter((_, idx) => idx !== i))} className="p-3 text-red-400 hover:bg-red-50 rounded-xl transition-all">
                                <FaTrash />
                            </button>
                        </div>
                    </div>
                ))}
                <button onClick={() => setSubItems([...subItems, { name: '', path: '' }])} className="flex items-center gap-2 text-[#006d5b] text-[10px] font-black uppercase p-4 hover:bg-emerald-50 rounded-2xl transition-all">
                    <FaPlusCircle /> Add Another Page
                </button>
            </div>

            <button onClick={saveMenu} className="w-full mt-10 py-5 bg-[#006d5b] text-white font-black rounded-[25px] tracking-[0.3em] shadow-xl shadow-emerald-100 uppercase text-xs">
                CONFIRM CHANGES <FaSave className="inline ml-2" />
            </button>
        </div>
    );
};

export default AddSidebarItem;